// FLAGS: none
// The IANA zone list offered by the session timezone picker.
/**
 * Timezone options for the session form. A short curated list covering the
 * EU markets OpenUp Events serves (EU-residency constraint), with
 * Europe/Amsterdam as the default. Kept small deliberately — schedulers pick
 * from familiar zones rather than the full IANA database.
 */
export const TIMEZONES: string[] = [
  "Europe/Amsterdam",
  "Europe/Brussels",
  "Europe/Berlin",
  "Europe/Paris",
  "Europe/Madrid",
  "Europe/Lisbon",
  "Europe/London",
  "Europe/Dublin",
  "Europe/Stockholm",
  "Europe/Helsinki",
];

export const DEFAULT_TIMEZONE = "Europe/Amsterdam";
